module.exports = __webpack_public_path__ + "static/img/pay-success.478175dc.png";